import config from "../../../config/index.js";
import Vue from "vue";
import http from "./http.js";
import store from "../../../store";

// 预约下载轮询定时器：宿主为模块变量，不绑定可能被销毁的页面组件实例
let appointmentTimer = null;

const util = {
  // 判断是否对象
  isObject: value => value != null && typeof value === "object",
  // 判断当前变量是否被定义（可用，不等于undefined或null）
  isDefined: value => value !== null && typeof value !== "undefined",
  // 复制两个对象上面具有相同的属性
  copySameProperty (target, source) {
    let copy;
    const _tmp = {};
    Object.keys(target).map(val => {
      if (val in source) {
        copy = source[val];
        _tmp[val] = copy;
      }
    });
    return _tmp;
  },
  // 深拷贝，太粗暴，待改善，！！
  deepCopy (obj) {
    if (util.isDefined(obj)) {
      return JSON.parse(JSON.stringify(obj));
    }
    return {};
  },
  /**
   * 转成int类型
   * @param  {any} val 被转的输入值
   * @param  {any} defaultValue 强转失败后的默认值
   * @return {int}     如果强转失败，则返回默认值
   */
  parseInt (val, defaultValue = 0) {
    val = parseInt(val, 10);
    return Number.isNaN(val) ? defaultValue : val;
  },
  // 获取当前时间戳.
  getTimestamp () {
    return new Date().getTime();
  },
  // 获取当前日期 xxxx-xx-xx
  getNowDate () {
    var year = new Date().getFullYear();
    var month = new Date().getMonth() + 1;
    var day = new Date().getDate();
    if (month < 10) {
      month = "0" + month;
    }
    if (day < 10) {
      day = "0" + day;
    }
    return year + "-" + month + "-" + day;
  },
  // 判断单位
  JudgmentUnit (unit) {
    if (sessionStorage.getItem('箱规是否能够使用小数点') && sessionStorage.getItem('箱规是否能够使用小数点') == 1) {
      return true
    }
    if (["KG", "公斤", "斤", "市斤", "米", "平方米", "CM", '吨', 'T'].includes(unit.toUpperCase())) {
      return true;
    }
    return false;
  },
  // 本地调试获取当前url
  getURLLocalHost (url) {
    if (!url.includes("http")) {
      const config = require("../../../config/index.js");
      let baseRightUrl = window.location.href;
      let rightData = baseRightUrl.split("/");
      if (rightData[2].includes("localhost")) {
        return (config.dev.proxyTable["/gys_users_req"].target.replace("/gys_users_req", "") + url);
      }
    }
    return url;
  },
  // 预约下载订单类型
  appointmentOperationList: [
    { id: 0, name: '未定义' },
    { id: 1, name: '历史价格导出' }
  ],
  团餐客户配送类型列表: [
    { id: 0, name: '全部自送' },
    { id: 1, name: '部分自送' },
    { id: 2, name: '全部第三方配送' }
  ],
  // 判断订单月份是否已关账，若已关账则不允许对订单进行修改
  isOrderClosed (date) {
    return JSON.parse(sessionStorage.getItem("accountCloseList")).includes(
      date.slice(0, 7)
    );
  },
  // 判断日期范围覆盖月份是否已关账，若已关账则不允许对订单进行修改
  isOrderClosedRange (dateRange) {
    const monthList = JSON.parse(sessionStorage.getItem("accountCloseList"));
    for (let i = 0; i < monthList.length; i++) {
      const [start, end] = dateRange.map(item => item.slice(0, 7));
      if (!((monthList[i] > start && monthList[i] > end) || (monthList[i] < start && monthList[i] < end))
      ) {
        return true;
      }
    }
    return false;
  },
  毛利表查询类型 () {
    let typeList = [
      { NAME: '全部', Stype: 'all' },
      { NAME: '自配', Stype: 'deliver' },
      { NAME: '第三方', Stype: 'third' }
    ]
    return typeList
  },
  // 列表去重
  listRemoveDuplicates (list) {
    return [...new Set(list.map(item => JSON.stringify(item)))].map(item => JSON.parse(item));
  },
  // 通过不同网址显示不同团餐公司的logo
  publicLogo () {
    const baseRightUrl = window.location.href;
    const rightData = baseRightUrl.split("/");
    switch (rightData[3]) {
      case 'SMP':
      case 'SCM':
        // return 'https://service.linkda.com.cn/file/tcpics/mjd/background.png'
        // return 'https://service1.mckintey.top/file/tcpics/mjd/background.png'
        // return 'https://service.linkda.com.cn/file/tcpics/Newcapec/background.png'
        // return 'https://service.linkda.com.cn/file/tcpics/yunpeng/background.png'
        return "https://service.linkda.com.cn/file/tcpics/lkd/background.png";

      case '#':
        // return 'https://service.linkda.com.cn/file/tcpics/mjd/background.png'
        // return 'https://service1.mckintey.top/file/tcpics/mjd/background.png'
        // return 'https://service.linkda.com.cn/file/tcpics/Newcapec/background.png'
        // return 'https://service.linkda.com.cn/file/tcpics/yunpeng/background.png'
        return "https://service.linkda.com.cn/file/tcpics/lkd/background.png";

      default:
        // this.imgUrl = 'https://service1.mckintey.top/file/tcpics/'+ rightData[3]+ '/background.png'
        return `https://service.linkda.com.cn/file/tcpics/${rightData[3]}/background.png`;
    }
  },
  tagIcon () {
    const baseRightUrl = window.location.href;
    const rightData = baseRightUrl.split("/");
    switch (rightData[3]) {
      case 'SMP':
      case 'SCM':
      case '#':
        return "https://service.linkda.com.cn/file/tcpics/lkd/favicon.ico";

      default:
        return `https://service.linkda.com.cn/file/tcpics/${rightData[3]}/favicon.ico`;
    }
  },
  tagTitle () {
    const baseRightUrl = window.location.href;
    const rightData = baseRightUrl.split("/");
    const titleDict = {
      ruijing: '睿景科技'
    }
    switch (rightData[3]) {
      case 'SMP':
      case 'SCM':
        return rightData[3];
      case '#':
        return 'SCM';

      default:
        return titleDict[rightData[3]] || 'SCM';
    }
  },
  showOrderStatus (status) {
    switch (Number(status)) {
      case 1:
      case 2:
        return '待送订单'
      case 3:
        return '待仓管验收'
      case 4:
        return '待项目经理验收'
      case 5:
        return '待档口负责人确认'
      case 6:
        return '待供应商确认'
      case 7:
      case 8:
      case 9:
        return '历史订单'
      default:
        return '其他'
    }
  },
  getCompanyType () {
    let typeList = [
      { NAME: '食品原材料类', Stype: '01' },
      { NAME: '低值易耗品类', Stype: '02' },
      { NAME: '工程类', Stype: '03' },
      { NAME: '设备类', Stype: '04' },
      { NAME: '行政类', Stype: '05' },
      { NAME: '人事类', Stype: '06' },
      { NAME: '服务类', Stype: '07' },
      { NAME: '系统类', Stype: '08' }
    ]
    return typeList
  },
  每页条数最大值: 500,

  // 预约下载未读列表轮询：不再依赖调用方传组件实例，判断/建表/清表全用模块变量
  async getUnreadInformation () {
    const params = {
      SERVICE_ID: '100631',
      OTYPE: 1,
      STATUS: [1, 2, 3],
      READ_STATUS: 0,
    };
    await http.post(params, { showLoading: false }).then((res) => {
      store.commit('SET_UNREAD_INFORMATION_LIST', res[0].LIST);

      if (store.getters.hasUnfinishedInformation) {
        if (!appointmentTimer) {
          appointmentTimer = setInterval(() => util.getUnreadInformation(), 60000);
        }
      } else {
        stopAppointmentPolling();
      }
    }).catch((err) => {
      Vue.prototype.$message.show({ text: err, type: 'error' });
    });
  },

  handleUploadSuccess (form, key, response, file, fileList) {
    this[form][key] = [...fileList]
  },
  handleUploadRemove (form, file, fileList) {
    this[form][key] = [...fileList]
  },
  appointmentMessage: `
    <span>导出任务记录成功！</span><br>
    <span>下载位置：<a href="${config.dev.isAliServer ? window.location.pathname : '/'}#/appointmentHandling">预约下载</a></span>
  `,
  QGP_TIME_TYPE: ['', '年', '季', '个月', '天', '小时'],
  getQGPValue ({ QGP, QGP_TIME_TYPE }) {
    return QGP && QGP_TIME_TYPE ? `${QGP}${util.QGP_TIME_TYPE[QGP_TIME_TYPE]}` : ''
  },
  async getAcceptanceQRCode (ORDER_ID) {
    let acceptanceQRCode = ''
    const params = {
      SERVICE_ID: '10004',
      OTYPE: 1000,
      ORDER_ID,
    };
    await http.post(params).then((res) => {
      acceptanceQRCode = res[0] || '';
    }).catch((error) => {
      Vue.prototype.$message.show({ text: error, type: 'error' });
    });
    return acceptanceQRCode
  },
};

/**
 * 停止预约下载轮询
 * 登录过期等场景由 http 层调用，避免以失效身份继续轮询并反复弹错
 */
export function stopAppointmentPolling () {
  if (appointmentTimer) {
    clearInterval(appointmentTimer);
    appointmentTimer = null;
  }
}

export default util;



// WEBPACK FOOTER //
// ./src/assets/common/util.js